import React, {useEffect, useState} from 'react'
import Chart from 'react-apexcharts'
import {Col, Row, Spinner, Stack} from 'react-bootstrap'
import { chartOptions } from '../../../utils/helper'

interface Props {
  data?: any
  heading: any
  subheading: any
  reload : boolean
}

function DonutPieChart({data, heading, subheading, reload }: Props) {
  const [utilSeries, setUtilSeries] = useState<any>([])
  const [total, setTotal] = useState<number>(0)
  const [colors, setColors] = useState<any>([])
  const [labels, setLabels] = useState<any>([])
  const [utilityMixData, setUtilityMixData] = useState<any>([])
  

  useEffect(() => {
    if(colors.length){
      updateData(data, colors)
    }
  }, [data, colors.length])

  useEffect(()=>{
    if(data?.tpvStatus?.length){
    const tempColor:any = [];
    data?.tpvStatus?.map((item:any)=>{
      switch (item.tpvStatusType){
      case 'PENDING': {
        tempColor.push('#F6C000') 
        break
      }
      case 'PASSED': {
        tempColor.push('#50CD89') 
        break
      }
      case 'INCOMPLETE': {
        tempColor.push('#7239EA') 
        break
      }
      case 'FAILED': {
        tempColor.push('#F1416C') 
        break
      }
      
    }
    setColors(tempColor);
    })
  }
  },[data?.tpvStatus?.length])

  const updateData = (utilityData: any, utilityColors: any) => {
    const utilitySeriesUpdated = utilityData?.tpvStatus?.map((item: any, i: any) => item?.tpvStatusCount)
    setUtilSeries(utilitySeriesUpdated)
    setTotal(utilityData?.totalTpvs)

    const utilityDataColors = utilityData?.tpvStatus?.map((value: any, item: any) => ({
      ...utilityData?.tpvStatus[item],
      color: utilityColors[item],
    }))
    const utilityDataLabels = utilityData?.tpvStatus?.map((value: any, item: any) => {
      return value.tpvStatusType;
    })
    setLabels(utilityDataLabels);
    setUtilityMixData(utilityDataColors)
  }

  const options: Object = chartOptions(labels, colors);

  

  return (
    <div className='card card-flush card-border mb-5 mb-xl-10 h-auto'  style={{minHeight:'365px'}}>
      <Stack gap={2} className='container mt-8 mb-5 ms-4'>
        <div className='text-dark fw-bolder fs-3'>{heading}</div>
        <Stack direction='horizontal' gap={2}>
          <div className='fw-bold fs-6 text-dark'>{total}</div>
          <div className='text-muted fs-6'>{subheading}</div>
        </Stack>
      </Stack>
      {reload ? (
        <div className="text-center mb-20">
          <Spinner animation="border" className="text-gray-600 text-center" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
      </div>) : (
      <div className='container'>
        <Row className='align-items-center'>
          <Col sm md lg='6'>
            <div className='position-relative d-flex flex-center mb-7'>
              <Chart
                type='donut'
                width={300}
                height={270}
                series={utilSeries || []}
                options={options}
                className='d-block'
              />
            </div>
          </Col>
          <Col sm md lg='6'>
            <Row>
              <Col lg md sm='6'>
                {utilityMixData?.slice(0, Math.floor(utilityMixData.length / 2)).map((item: any) => {
                  return (
                      <div
                        className='d-flex me-15 cap mb-8'
                        key={item.tpvStatusType}
                      >
                        <span
                          className='bullet bullet-dot h-10px w-10px me-3 mt-2'
                          style={{backgroundColor: `${item?.color}`}}
                        />
                        <Stack>
                          <span className='fw-bold fs-2'>
                            {item?.tpvStatusCount}
                          </span>
                          <span className='fs-6' style={{color: `${item?.color}`}}>
                            {item?.tpvStatusType}
                          </span>
                        </Stack>
                      </div>
                  )
                })}

              </Col>
              <Col lg md sm="6">
              {utilityMixData?.slice(Math.floor(utilityMixData.length / 2)).map((item: any) => {
                return (
                    <div className='d-flex me-15 cap mb-8' key={item.tpvStatusType}>
                      <span
                        className='bullet bullet-dot h-10px w-10px me-3 mt-2'
                        style={{backgroundColor: `${item?.color}`}}
                      ></span>
                      <Stack>
                        <span className='fw-bold fs-2'>{item?.tpvStatusCount}</span>
                        <span className='fs-6' style={{color: `${item?.color}`}}>
                          {item?.tpvStatusType}
                        </span>
                      </Stack>
                    </div>
                )
              })}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      )}
    </div>
  )
}

export default DonutPieChart
